/**
 * Format a Date as "YYYY-MM-DD" from its LOCAL calendar parts.
 *
 * `date.toISOString().split("T")[0]` converts to UTC first, so for users east
 * of UTC (Norway is UTC+1/+2) a local date constructed at midnight serializes
 * as the PREVIOUS day. Use this helper wherever the app means "the user's
 * calendar date" — form defaults, payday dates, period boundaries.
 */
export function toLocalDateString(date: Date = new Date()): string {
  const y = date.getFullYear()
  const m = `${date.getMonth() + 1}`.padStart(2, "0")
  const d = `${date.getDate()}`.padStart(2, "0")
  return `${y}-${m}-${d}`
}

/**
 * Derive the recurring day-of-month and day-of-week from a "YYYY-MM-DD" string
 * so picking a charge date auto-fills the schedule. The date parts are read
 * directly (no `new Date(str)`, which would parse as UTC and land a day early
 * east of Greenwich); the weekday is computed from a local Date. Returns null
 * for a malformed/empty string.
 */
export function scheduleDaysFromDate(value: string): { dayOfMonth: number; dayOfWeek: number } | null {
  const [y, m, d] = value.split("-").map(Number)
  if (!y || !m || !d) return null
  return { dayOfMonth: d, dayOfWeek: new Date(y, m - 1, d).getDay() }
}
